<script setup lang="ts">
import { useI18n } from 'vue-i18n';

/**
 * The `*` after a required field's label. The star is hidden from screen
 * readers, which hear "Required" instead.
 */
const { t } = useI18n();
</script>

<template>
    <span data-testid="required-mark"><span class="text-destructive" aria-hidden="true">*</span><span class="sr-only">{{ t('common.required') }}</span></span>
</template>
